import { SocketRoomEvent } from '../tenant.notification.payload';
import { RoomKey } from '../socket.room.key';
import { PublicApiRateLimitState } from '../../settings/public.api.settings';

export const PublicApiRateLimitEventType = {
    Updated: 'updated',
    Cleared: 'cleared',
} as const;

export type PublicApiRateLimitRoomMessage =
    | SocketRoomEvent<typeof PublicApiRateLimitEventType.Updated, PublicApiRateLimitState>
    | SocketRoomEvent<typeof PublicApiRateLimitEventType.Cleared, PublicApiRateLimitState>;

export const PublicApiRateLimitSettingsRooms = {
    publicApiRateLimit: (): RoomKey<PublicApiRateLimitRoomMessage> => ({ key: 'settings:public-api-rate-limit' }),
};
